import { z } from 'zod';

/**
 * Schema for updating organization details.
 * Matches backend constraints from Epic 4.
 */
export const orgUpdateSchema = z.object({
  name: z
    .string()
    .trim()
    .min(3, 'Organization name must be at least 3 characters')
    .max(255, 'Organization name must be less than 255 characters'),
  description: z
    .string()
    .max(1000, 'Description must be less than 1000 characters')
    .optional()
    .or(z.literal('')),
});

export type OrgUpdateFormData = z.infer<typeof orgUpdateSchema>;
